export enum ChargeComponent {
  PAYROLL_MONTHLY_FEE = 'PAYROLL_MONTHLY_FEE',
  PAYROLL_QUARTERLY_FEE = 'PAYROLL_QUARTERLY_FEE',
  PAYSTUB = 'PAYSTUB',
  QUARTER_REPORT = 'QUARTER_REPORT',
  TIMESHEET = 'TIMESHEET',
  POSTAL_REGISTER_MONTHLY_FEE = 'POSTAL_REGISTER_MONTHLY_FEE',
  INVOICES = 'INVOICES',
  SUBLIME_DOCS = 'SUBLIME_DOCS'
}

export enum UsageUnit {
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  SEAT = 'SEAT',
  ITEM = 'ITEM',
}

export enum ChargeStatus {
  DRAFT = 'DRAFT',
  POSTED = 'POSTED',
  INVOICED = 'INVOICED',
  VOIDED = 'VOIDED',
}

export default interface SublimeChargeDTO {
  component: ChargeComponent;
  unit: UsageUnit;
  quantity: number;
  currency: string;
  listUnitPriceCents: number;
  listAmountCents: number;
  discountTotalCents: number;
  netAmountCents: number;
  periodStart: string; // ISO LocalDate
  periodEnd: string;   // ISO LocalDate
  status: ChargeStatus;
  attributes?: Record<string, any | null>;
}
